module.exports = __webpack_public_path__ + "static/media/chevron-right.47f94592.svg";